import React, { cloneElement } from 'react';
import { motion } from 'framer-motion';
import { EyeOff, HeartHandshake, BrainCircuit, Anchor, Feather, ShieldCheck, Compass, KeyRound, Sunrise } from 'lucide-react';
export function BenefitsGrid() {
  const benefits = [{
    icon: <EyeOff data-id="element-24" />,
    title: 'Dejas de revisar',
    desc: 'Pierdes la urgencia de ver qué hace o con quién está.'
  }, {
    icon: <HeartHandshake data-id="element-25" />,
    title: 'Paz emocional',
    desc: 'Tu pecho deja de sentirse apretado por la ansiedad.'
  }, {
    icon: <BrainCircuit data-id="element-26" />,
    title: 'Claridad mental',
    desc: 'Liberas espacio en tu mente para tus propios proyectos.'
  }, {
    icon: <Anchor data-id="element-27" />,
    title: 'Recuperas tu centro',
    desc: 'Vuelves a ser la dueña de tus emociones y decisiones.'
  }, {
    icon: <Feather data-id="element-28" />,
    title: 'Sueltas el apego',
    desc: 'Entiendes cómo desengancharte desde la raíz.'
  }, {
    icon: <ShieldCheck data-id="element-29" />,
    title: 'Límites internos',
    desc: 'Aprendes a proteger tu energía de la nostalgia.'
  }, {
    icon: <Compass data-id="element-30" />,
    title: 'Dirección clara',
    desc: 'Dejas de mirar al pasado y te enfocas en tu presente.'
  }, {
    icon: <KeyRound data-id="element-31" />,
    title: 'Cierre definitivo',
    desc: 'Te das a ti misma la resolución que estabas esperando.'
  }, {
    icon: <Sunrise data-id="element-32" />,
    title: 'Renacimiento',
    desc: 'Te conectas con una versión más fuerte y sabia de ti.'
  }];
  return <section className="py-24 px-4 bg-cream relative overflow-hidden" data-id="element-33">
      <div className="absolute top-1/2 right-0 w-96 h-96 bg-soft/15 rounded-full blur-3xl pointer-events-none" data-id="element-34"></div>

      <div className="max-w-5xl mx-auto relative" data-id="element-35">
        <div className="text-center mb-14" data-id="element-36">
          <div className="mb-10 max-w-3xl mx-auto" data-id="element-37">
            <img src="https://cdn.magicpatterns.com/uploads/aMWfqr3jBiePfpBJBvhSfu/ChatGPT_Image_5_may_2026,_05_42_42_a.m..png" alt="Sanar también es elegirte a ti — Hoy es un buen día para empezar" className="w-full h-auto rounded-2xl shadow-xl border border-soft/30" data-id="element-38" />
          </div>
          <span className="font-sans text-accent text-xs font-bold tracking-[0.25em] uppercase mb-3 block" data-id="element-39">
            ✦ Tu Transformación ✦
          </span>
          <h2 className="font-serif font-bold text-3xl md:text-5xl text-primary mb-4" data-id="element-40">
            Lo que experimentas al aplicar el sistema:
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6" data-id="element-41">
          {benefits.map((b, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.05
        }} className="group flex flex-col items-start p-6 rounded-2xl bg-white border border-soft/30 shadow-md hover:shadow-xl hover:-translate-y-1 transition-all" data-id="element-42">
              <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-accent to-primary text-white flex items-center justify-center mb-4 shadow-md group-hover:scale-110 transition-transform" data-id="element-43">
                {cloneElement(b.icon as React.ReactElement, {
              size: 22,
              strokeWidth: 1.8
            })}
              </div>
              <h3 className="font-serif font-bold text-lg text-primary mb-2" data-id="element-44">
                {b.title}
              </h3>
              <p className="text-ink/70 text-sm leading-relaxed font-sans" data-id="element-45">
                {b.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}